<script>
	import { onMount } from "svelte";

	export let id = null;
	export let label = null;
	export let value;
	export let disabled = null;
	export let readonly = null;
	export let required = null;
	export let placeholder = null;
	export let optionList;

	let searchInput;
	let autoComplete;
	let filteredOptionList = [];

	const keyCodes = {
		up: 38,
		down: 40,
		enter: 13,
		escape: 27,
		tab: 9
	};

	console.log(optionList);

	const keyCodesArray = Object.keys(keyCodes).map((k) => keyCodes[k]);

	const filterOptions = () => {
		let filteredList = [];
		if (value && !disabled) {
			filteredList = optionList
				.filter((o) => o.toLowerCase().indexOf(value.toLowerCase()) >= 0)
				.map((o) => styleMatch(o));

			if (filteredList.length === 1 && value.toLowerCase() === filteredList[0].toLowerCase()) {
				filteredList = [];
			}
		}

		filteredOptionList = [...filteredList];
	};

	const itemSelected = (label, e) => {
		value = removeStyle(label);

		filteredOptionList = [];
		searchInput.focus();
	};

	const styleMatch = (str) => {
		let matched = str.substring(0, value.length);
		let makeBold = `<span style="color: var(--highlight-color);">${matched}</span>`;
		let boldedMatch = str.replace(matched, makeBold);
		return boldedMatch;
	};

	const removeStyle = (str) => {
		//replace < and > all characters between
		return str.replace(/<(.)*?>/g, "");
	};

	const checkForFocusLoss = (evt) => {
		if (!filteredOptionList.length > 0) return;
		let el = evt.target;

		do {
			if (el === autoComplete) return;
		} while ((el = el.parentNode));
		close();
	};

	const handleKeyPress = (evt) => {
		if (keyCodesArray.indexOf(evt.keyCode) === -1) return;

		console.log(evt.keyCode);
		switch (evt.keyCode) {
			case keyCodes.up:
				break;
			case keyCodes.down:
				break;
			case keyCodes.escape:
			case keyCodes.tab:
				close();
				break;
			case keyCodes.enter:
				break;
			default:
				break;
		}
	};

	const close = () => {
		filteredOptionList.length = 0;
	};

	onMount(() => {
		document.addEventListener("keydown", handleKeyPress);
		document.addEventListener("click", checkForFocusLoss);

		return () => {
			document.removeEventListener("keydown", handleKeyPress);
			document.removeEventListener("click", checkForFocusLoss);
		};
	});
</script>

{#if label !== null}<label for={id} class:isrequired={required}>{label}</label>{/if}
<div class="autocomplete" bind:this={autoComplete}>
	<input
		{required}
		{disabled}
		{readonly}
		{placeholder}
		type="text"
		bind:value
		bind:this={searchInput}
		{id}
		class="form-control {$$props.class}"
		on:input={() => filterOptions()}
		on:change
	/>

	{#if filteredOptionList.length > 0}
		<ul>
			{#each filteredOptionList as label}
				<li on:click={(e) => itemSelected(label, e)}>{@html label}</li>
			{/each}
		</ul>
	{/if}
</div>

<style>
	.autocomplete {
		width: 100%;
		position: relative;
	}

	ul {
		max-height: 200px;
		overflow-x: auto;
		overflow-y: hidden;
		position: absolute;
		top: 48px;
		left: 0;
		right: 0;
		padding: 0;
		margin: 2px 0 0 0;
		z-index: 100;
		box-shadow: 3px 4px 6px 0px rgb(0, 0, 0, 0.2);
	}

	.autocomplete ul li:first-child {
		border-top: 1px solid var(--color-border);
	}

	.autocomplete ul li:last-child {
		border-bottom: 1px solid var(--color-border);
	}

	li {
		font-size: 16px;
		list-style: none;
		padding: 2px 6px;
		border-left: 1px solid var(--color-border);
		border-right: 1px solid var(--color-border);
		background-color: #fff;
	}

	li:hover {
		background-color: #1e90ff;
		color: #fff;
		cursor: pointer;
	}
</style>
